module.exports = __webpack_public_path__ + "static/media/entrance.6eca302d.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/story/bg/entrance.jpeg
// module id = 81
// module chunks = 0